export class ActuatorType {
    public id!: number;
    public name!: string;
    public lowerCaseName!: string;
    public maintenanceListForms?: MaintenanceListForm[];
    public maintenanceListElementEntries?: MaintenanceListElementEntry[];
  
    constructor(actuatorTypeData: any) {
      Object.assign(this, actuatorTypeData);
    }
  
    // Helper methods to get filtered form entries
    get conditionFormEntries(): MaintenanceListElementEntry[] {
      return this.maintenanceListElementEntries?.filter(entry => entry.formType === 'condition') || [];
    }
  
    get functionFormEntries(): MaintenanceListElementEntry[] {
      return this.maintenanceListElementEntries?.filter(entry => entry.formType === 'function') || [];
    }
  
    // Helper method to get maintenance list elements from form entries
    get maintenanceListElements(): MaintenanceListElement[] {
      const elements = new Map<number, MaintenanceListElement>();
      
      this.maintenanceListElementEntries?.forEach(entry => {
        if (entry.element && !elements.has(entry.element)) {
          // You might need to fetch the full MaintenanceListElement data
          // This is a simplified version
          elements.set(entry.element, {
            id: entry.element,
            description: '', // You'd need to fetch this from the backend
            formEntries: this.maintenanceListElementEntries?.filter(e => e.element === entry.element)
          });
        }
      });
  
      return Array.from(elements.values());
    }
  }

// Define the interfaces for the new structure
export interface MaintenanceListForm {
  id: number;
  name: string;
  actuatorType: number;
  maintenanceListElementEntries?: MaintenanceListElementEntry[];
  formType: 'condition' | 'function';
  // Add other properties as needed
}

export interface MaintenanceListElementEntry {
  id: number;
  actuatorType: number;
  element?: number;
  formType: 'condition' | 'function';
  // Add other properties as needed
}

export interface MaintenanceListElement {
  id: number;
  description: string;
  formEntries?: MaintenanceListElementEntry[];
} 